<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="mapping-main">
    <PopupEntry
      v-if="pShowPopup"
      :show.sync="pShowPopup"
      :successMessages="successMessages"
      :errorMessages="errorMessages"
      :requiredError="requiredError"
      title="Template Mapping"
      style="font-size: 12px; overflow: scroll"
      @save="saveClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div style="overflow: scroll; padding: 3px">
        <div>
          <Input
            placeholder="Template Name"
            :inputValue.sync="pTemplateName"
            :isDisabled="disableTemplateName"
            :isRequired="true"
            validator="text,200"
          />
        </div>
        <div style="display: flex">
          <div style="width: 15%; text-align: center"><b>Target Fields</b></div>
          <img src="https://dsmlib.logistics.systems/Icons/Right Arrow.png" />
          <div style="width: 85%; text-align: center"><b>Custom Fields</b></div>
        </div>
        <div v-for="(field, i) in pTargetFields" :key="field['key']">
          <div style="display: flex">
            <!-- <Input :placeholder="`Target Field ${i + 1}`" :inputValue="field['key']" :isDisabled="true" /> -->
            <div style="width: 40%">{{ i + 1 }}. {{ field['key'] }}</div>
            <Dropdown
              :placeholder="`Select field to map to ${field['key']}`"
              :items="pSourceFields"
              itemKey="key"
              :isRequired="field['required']"
              :selectedObject.sync="pMappedFields[field['key']]['field']"
              :errorMessage.sync="pMappedFields[field['key']]['error']"
              :isDisabled="viewMode"
              @selected="customFieldSelected($event, field['key'])"
            />
            <Input
              :placeholder="'Default Value'"
              :inputValue.sync="pMappedFields[field['key']]['defaultValue']"
              :errorMessage.sync="pMappedFields[field['key']]['defaultValueError']"
              :isDisabled="field['disableFixedValue'] || viewMode"
              :isRequired="!field['disableFixedValue']"
              validator="text,100"
            />
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      pShowPopup: false,
      pTargetFields: [],
      pMappedFields: {},
      pSourceFields: [],
      fixedValueIndicator: '-',
      pTemplateName: '',
    };
  },
  props: {
    showPopup: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    targetFields: {
      type: Array,
      default: function () {
        return [];
      },
    },
    sourceFields: {
      // Must be an array of objects with a 'key' property
      type: Array,
      default: function () {
        return [];
      },
    },
    mappedFields: {
      type: Object,
      default: function () {
        return {};
      },
    },
    templateName: {
      type: String,
      default: function () {
        return '';
      },
    },
    successMessages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    errorMessages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    disableTemplateName: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    viewMode: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  methods: {
    customFieldSelected: function (source, target) {
      this.pTargetFields.find((field) => field.key == target).disableFixedValue =
        !source || source.key !== this.fixedValueIndicator;
      if (source.key !== this.fixedValueIndicator) {
        this.pMappedFields[target] = {
          ...this.pMappedFields[target],
          defaultValue: '',
        };
      }
    },
    saveClicked: function () {
      this.$emit('update:mappedFields', this.pMappedFields);
      this.$emit('update:templateName', this.pTemplateName);
      this.$emit('saveMappingClicked');
    },
  },
  // mounted() {},
  watch: {
    showPopup: function (val) {
      this.pShowPopup = val;

      if (val) {
        for (const key in this.pMappedFields) {
          const source = this.pMappedFields[key].field;
          if (source) {
            this.customFieldSelected(source, key);
          } else {
            this.pTargetFields.find((field) => field.key == key).disableFixedValue = true;
          }
        }
      }
    },

    pShowPopup: function (val) {
      this.$emit('update:showPopup', val);
    },

    targetFields: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.pTargetFields = val.map((field) => {
          return {
            ...field,
            disableFixedValue: true,
          };
        });
      },
    },

    mappedFields: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.pMappedFields = val;
      },
    },

    sourceFields: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.pSourceFields = [{ key: this.fixedValueIndicator }, ...val];
      },
    },

    templateName: function (val) {
      this.pTemplateName = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.mapping-main {
  font-size: 12px;
}
</style>
